import React, { useEffect, useState } from 'react';
import { db } from '../../../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../../../../context/AuthContext';

const PartyName = ({ partyID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [data, setData] = useState(null);

  async function getPartyData(pid) {
    const docRef = doc(db, "Businesses", bid, "Parties", pid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setData(docSnap.data());
    } else {
      console.log("No party found!");
    }
  }

  useEffect(() => {
    getPartyData(partyID);
  }, [])

  return data && data.partyName ? data.partyName : "-";
}

export default PartyName;
